import { mapGetters } from "vuex";

export default {
    data(){return {
        classesAvailable: [
            "octolo",
            "primarylight",
            "secondary",
            "secondarylight",
            "success",
            "red",
            "yellow",
            "gray",
            "graylight",
            "danger",
            "small",
            "big"
        ],
    }},
    props: {
        primarylight: { type: Boolean, },
        secondary: { type: Boolean, },
        secondarylight: { type: Boolean, },
        gray: { type: Boolean, },
        graylight: { type: Boolean, },
        success: { type: Boolean, },
        red: { type: Boolean, },
        yellow: { type: Boolean, },
        danger: { type: Boolean, },
        octolo: { type: Boolean, },
        small: { type: Boolean, },
        big: { type: Boolean, },
        lvl: { type: String },
    },
    computed: {
        ...mapGetters("Appv2", ["isPhone", "isTablet", "isLaptop", "classRule"]),
        classes(){
            return this.classesAvailable.filter(cls => this[cls]);
        },
    },
    methods: {
        isLaptopPr(pr){
            return this.isLaptop ? `w-[${pr}%]` : "";
        },
        checkBreakRules() {
            this.$store.dispatch("Appv2/checkBreakRules");
        },
        styleImage(url){ return "background-image: url('"+url+"')"; },
        padZero(str, len) {
            len = len || 2;
            var zeros = new Array(len).join('0');
            return (zeros + str).slice(-len);
        },
        invertColor(hex, bw) {
            if (!hex) return "#000000";
            if (hex.indexOf('#') === 0) hex = hex.slice(1);
            if (hex.length === 3)
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            if (hex.length !== 6)
                throw new Error('Invalid HEX color.');
            if (bw) return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF';
            var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
                g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
                b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
            return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
        },
        hexToRGB(hex, alpha) {
            var r = parseInt(hex.slice(1, 3), 16),
                g = parseInt(hex.slice(3, 5), 16),
                b = parseInt(hex.slice(5, 7), 16);

            if (alpha) {
                return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
            } else {
                return "rgb(" + r + ", " + g + ", " + b + ")";
            }
        },
        // A supprimer
        imageUrl(url){ return "background-image: url('"+url+"');"; },
        image_url(url){ return "background-image: url('"+url+"');"; },
        bgColor(color){ return "background-color: "+color+";"; },
        ftColor(color){ return "color: "+color+";"; },
        bgColorAutoFont(color, bw){ return this.bgColor(color)+this.ftColor(this.invertColor(color, bw)); },
        baseClass(){ return ""; },
    }
}

